import { useEffect,useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../actions/index";
import { AddAccountManager } from "../../components/add_account_manager";
import  DataMigrationConfig  from "../../../migration/create-migration/util/dataMigrationConfig";
import Datepicker from "react-tailwindcss-datepicker";
import moment from "moment";



import {
  FileChooser,
  SearchDropdown,
  TextBox,
} from "../../../../components/inputs";

import {
  CompanyStatus,
  countries,
  currencies,
  regions,
  timezones,
  verticals,
} from "../../../../util/master-data";

export function CustomerDetails({ formik, readOnly }) {
  const dispatch = useDispatch();
  const industryList = useSelector((state) => state.company.industry);
  const oppositeENVRegionList = useSelector((state) => state?.migration?.migration_regions);
  const cloneSourceAccounts = useSelector((state) => state?.migration?.migration_default_object?.sourceCompanyDetails);
  const [cloneAccountIndustry,setCloneAccountIndustry] = useState(["None"])
  const migrationTypeOptions = ["Config","Config And Data"]
  const currentENVRegionList = JSON.parse(localStorage.getItem("regions")); // region from localstorage

  useEffect(() => {
    dispatch(actions.GETINDUSTRY_REQ({ no_loader: true }));
    dispatch(actions.GETOPPOSITEENVREGION_REQ());
    dispatch(actions.GETMIGRATIONDEFAULTOBJECT_REQ());
  }, []);

  useEffect(() => {
      if(cloneSourceAccounts && cloneSourceAccounts.length > 0){
          setCloneAccountIndustry(["None",...cloneSourceAccounts.map((obj) => obj.industry)])
      }
      },[cloneSourceAccounts]);

  useEffect(() => {
        if (oppositeENVRegionList?.data) {
            formik.setFieldValue('regionObjectList', [...oppositeENVRegionList?.data, ...currentENVRegionList])
        }
    }, [oppositeENVRegionList]);

  useEffect(() => {
        if(formik?.values?.cloneAccount && formik?.values?.cloneAccount != "None"){
        let payload = cloneSourceAccounts.find((item) => item.industry == formik?.values?.cloneAccount)
        formik.setFieldValue('from_company_region', payload?.region) 
        formik.setFieldValue('from_company_login_name', payload?.company_login_name)
        formik.setFieldValue('from_company_name', payload?.company_name)
        formik.setFieldValue('from_api_key', payload?.zuper_api_key)
        formik.setFieldValue('from_company_uid', payload?.company_uid)
        formik.setFieldValue('isDataMigrationEnabled',true)
        formik.setFieldValue('from_company_ref_date', payload?.from_company_ref_date )
     }
     else if(formik?.values?.cloneAccount == "None"){
      formik.setFieldValue('isDataMigrationEnabled',false)
    }
    },[formik?.values?.cloneAccount])

  useEffect(() => {
    if(formik?.values?.company_status === "SALE"){
      // Set trial_period to 14 days from today if not already set (only in create/edit mode, not readonly)
      if(!formik?.values?.trial_period && !readOnly){
        formik.setFieldValue('trial_period', moment().add(14, 'days').format('YYYY-MM-DD'))
      }
    } else {
      // Clear trial_period if company_status is not SALE (only in create/edit mode, not readonly)
      if(!readOnly){
        formik.setFieldValue('trial_period', null)
      }
    }
  },[formik?.values?.company_status, readOnly])

  return (
    <>
      <div className="grid mt-4 mb-4 grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2">
        <TextBox
          formik={formik}
          readOnly={readOnly}
          name="company_name"
          label="Company Name"
          placeholder="Company Name"
        />
        <TextBox
          formik={formik}
          readOnly={readOnly}
          name="company_login_name"
          label="Company Login Name"
          placeholder="Company Login Name"
        />
        <FileChooser
          formik={formik}
          readOnly={readOnly}
          name="company_logo"
          label="Company Logo"
          placeholder="Company Logo"
          accept=".png,.jpg,.jpeg"
        />{" "}
        <SearchDropdown
          formik={formik}
          readOnly={readOnly}
          name="company_status"
          label="Stage"
          showNull={false}
          options={CompanyStatus}
        />
        <SearchDropdown
          formik={formik}
          readOnly={readOnly}
          name="company_industry"
          label="Industry type"
          showNull={true}
          options={industryList}
          optionId="value"
          optionName="label"
        />
        <TextBox
          formik={formik}
          readOnly={readOnly}
          name="company_email"
          label="Company Email"
          placeholder="Company Email"
        />
        <TextBox
          formik={formik}
          readOnly={readOnly}
          type="tel"
          name="company_phone"
          label="Company Phone"
          placeholder="Company Phone"
        />
        <SearchDropdown
          formik={formik}
          readOnly={readOnly}
          name="company_country"
          options={countries}
          showNull={false}
          optionId="value"
          optionName="label"
          label="Country"
          placeholder="Company Country"
        />
        <TextBox
          formik={formik}
          readOnly={readOnly}
          name="company_address"
          label="Company Address"
          placeholder="Company Address"
        />
        <SearchDropdown
          formik={formik}
          readOnly={readOnly}
          name="company_currency"
          label="Company Currency"
          showNull={false}
          placeholder="Company Currency"
          options={currencies}
          formatDisplayName={(currency) =>
            `${currency.currencyName} ${currency.currencySymbol ? "(" + currency.currencySymbol + ")" : ""
            }`
          }
          optionId="id"
          optionName="currencyName"
        />
        <SearchDropdown
          formik={formik}
          readOnly={readOnly}
          showNull={false}
          name="company_timezone"
          label="Company Timezone"
          placeholder="Company Timezone"
          options={timezones}
          optionName="display_name"
        />
        <SearchDropdown
          formik={formik}
          readOnly={readOnly}
          name="region"
          showNull={false}
          options={regions}
          optionId="code"
          optionName="full_name"
          label="Region"
          placeholder="Region"
        />
        <SearchDropdown
          formik={formik}
          readOnly={readOnly}
          name="company_verticals"
          label="Company Verticals"
          placeholder="Company Verticals"
          options={verticals}
          optionName="label"
          optionId="value"
        />
        <AddAccountManager
          formik={formik}
          readOnly={readOnly}
          name="account_manager"
          title="Add"
          label="Account Manager"
          placeholder="Account Manager"
        />

        {formik?.values?.company_status === "SALE" && (
          readOnly ? (
            <div className="mt-1">
              <label className="mb-2 block text-sm font-medium text-gray-700 mb-2">
                Trial Period
              </label>
              <div className="text-gray-900">
                {formik.values.trial_period ? moment(formik.values.trial_period).format('YYYY-MM-DD') : '---'}
              </div>
            </div>
          ) : (
            <div className="mt-1">
              <label className="mb-2 block text-sm font-medium text-gray-700 mb-1">
                Trial Period
              </label>
              <Datepicker
                classNames={{
                  footer: (p) => `
                      px-2
                      pb-2
                      [&_button:first-of-type]:!bg-white
                      [&_button:first-of-type]:!rounded-md
                      [&_button:first-of-type]:!shadow-sm
                      [&_button:first-of-type]:!disabled:bg-gray-200
                      [&_button:first-of-type]:!disabled:opacity-50
                      [&_button:first-of-type]:!text-gray-900
                      [&_button:first-of-type]:!font-semibold
                      [&_button:first-of-type]:!ring-gray-300
                      [&_button:first-of-type:hover]:!bg-gray-50
                      [&_button:first-of-type]:!ring-1
                      [&_button:first-of-type]:!ring-inset
                      [&_button]:w-[100px]
                      [&_button]:ml-auto
                      [&_button]:cursor-pointer
                      [&_button]:bg-gray-800
                      [&_button]:rounded-md
                      [&_button]:shadow-sm
                      [&_button]:disabled:bg-gray-500
                      [&_button]:disabled:opacity-75
                      [&_button]:text-white
                      [&_button]:font-semibold
                      [&_button:hover]:bg-gray-600
                      [&_button:focus-visible]:outline-gray-600
                      [&_button:focus-visible]:outline
                      [&_button:focus-visible]:outline-2
                      [&_button:focus-visible]:outline-offset-2`,
                }}
                containerClassName={(p) => `
                      relative w-full text-gray-700
                      [&_.bg-indigo-100]:!bg-gray-100
                      [&_.bg-indigo-500]:!bg-gray-800
                      [&_.line-through]:text-gray-200
              `}
                placeholder="Select trial period date"
                primaryColor="indigo"
                value={formik.values.trial_period ? {
                  startDate: formik.values.trial_period,
                  endDate: formik.values.trial_period
                } : {
                  startDate: moment().add(14, 'days').format('YYYY-MM-DD'),
                  endDate: moment().add(14, 'days').format('YYYY-MM-DD')
                }}
                onChange={(value) => formik.setFieldValue('trial_period', value?.startDate || null)}
                showFooter
                asSingle
                minDate={new Date()}
                displayFormat="DD-MM-YYYY"
                popoverDirection="down"
              />
            </div>
          )
        )}

        <SearchDropdown
        formik={formik}
        required = {false}
        readOnly={readOnly}
        className=" w-full [&_.disabled-option]:!bg-transparent [&_.disabled-option]:rounded-none [&_.disabled-option]:border-b-[1px] [&_.disabled-option]:border-[#b9b7b7ba] [&_.disabled-option]:mb-3"
        name="cloneAccount"
        label="Clone from Standard Account"
        showNull={false}
        options={cloneAccountIndustry ? cloneAccountIndustry : []}
        />

        {formik?.values?.cloneAccount && formik?.values?.cloneAccount != "None" ? <SearchDropdown
        formik={formik}
        required = {false}
        readOnly={readOnly}
        className=" w-full [&_.disabled-option]:!bg-transparent [&_.disabled-option]:rounded-none [&_.disabled-option]:border-b-[1px] [&_.disabled-option]:border-[#b9b7b7ba] [&_.disabled-option]:mb-3"
        name="migrationType"
        label="Select Type of Migration"
        showNull={false}
        options={migrationTypeOptions ? migrationTypeOptions : []}
        /> : ""}  
      </div>
    </>
  );
}
